import React, { useContext } from 'react';
import { bool } from 'prop-types';
import useStyles from 'hooks/useStyles';
import CourseContext from 'routes/course/components/CourseContext';
import { CloseIcon } from 'components/Icon';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './LessonUnitHeader.scss';
import { useTranslation } from 'react-i18next';

function LessonUnitHeader({ show }) {
  useStyles(styles);

  const { t } = useTranslation(['course']);

  const { onLessonListPopupModeClose, lessonListIsPopupMode } = useContext(
    CourseContext,
  );

  if (!show) return null;

  return (
    <div className={styles.root}>
      <h5>{t(`videoplayer.label.lessons`)}</h5>
      {lessonListIsPopupMode && (
        <div className={styles.icon} onClick={onLessonListPopupModeClose}>
          <CloseIcon />
        </div>
      )}
    </div>
  );
}

LessonUnitHeader.propTypes = {
  show: bool,
};

LessonUnitHeader.defaultProps = {
  show: false,
};

export default LessonUnitHeader;
